module.exports = __webpack_public_path__ + "static/media/16.2784c9e0.png";